<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-10-14 11:12:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-01-31 18:17:35
 * @FilePath: /goldenSalesMobile/src/views/ShoppingList/index.vue
 * @Description: 工单列表
-->
<template>
  <div class="order-page-container">
    <!-- goods-list -->
    <div class="tab-list f-1">
      <van-tabs
        v-model="acIdx"
        swipeable
        sticky
        color="var(--tc)"
        title-active-color="var(--tc)"
        title-inactive-color="#666666"
        @change="onTabChange"
      >
        <van-pull-refresh
          v-model="refreshing"
          @refresh="init"
          v-if="tabList.length > 0"
        >
          <van-tab
            v-for="(item, index) in tabList"
            :key="index"
            :name="item.Id"
            :title="item.Name"
            :swipe-threshold="5"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              :error.sync="loadError"
              :immediate-check="false"
              :offset="30"
              error-text="请求失败，点击重新加载"
              finished-text=""
              @load="onLoad"
            >
              <!-- <orderListComp
                :datas="datas"
                @delete="deleteItem"
              ></orderListComp> -->
              <div class="c-m-20">
                <div
                  v-for="(v, i) in datas"
                  :key="i"
                  class="c-bg-white c-m-b-20 order_item_con c-b-r-20"
                  @click="toOrderDetail(v)"
                >
                  <div class="c-fl-bt top-line-box">
                    <div><span>商户：</span>{{ v.TenantName }}</div>
                    <div
                      :class="[
                        v.State == '待激活'
                          ? 'order_status_con_0'
                          : v.State == '已取消'
                          ? 'order_status_con_2'
                          : '',
                        'order_status_con',
                      ]"
                    >
                      {{ v.State }}
                    </div>
                  </div>
                  <div class="order_bottom_con">
                    <div class="r-box">
                      <div class="m-t-10">
                        <span>设备码：</span>{{ v.DeviceCode }}
                      </div>
                      <div class="m-t-10">
                        <span>激活码：</span>{{ v.UserCode }}
                      </div>
                      <div class="m-t-10">
                        <span>终端名称：</span>{{ v.ClientId }}
                      </div>
                      <div class="m-t-10">
                        <span>操作人：</span>{{ v.IdentityName }}
                      </div>
                      <div class="m-t-10">
                        <span>申请时间：</span>{{ v.CreationTimeTxt }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-tab>
        </van-pull-refresh>
        <van-empty v-if="datas.length === 0" description="暂无数据" />
      </van-tabs>
    </div>

    <!-- <g-no-content
      v-if="datas.length === 0"
      title="您暂时没有相关订单"
      class="no-order-content f-1"
    ></g-no-content> -->
  </div>
</template>

<script>
import { getEquipAuthList } from "@/api/equip";
import { handleLocalStorage, getCurrentPreviousDay } from "@/utils";
export default {
  name: "EquipOrderList",
  components: {},
  data() {
    return {
      loading: false,
      refreshing: false,
      finished: false,
      loadError: false,
      acIdx: -1,
      tabList: [
        { Name: "全部", Id: -1 },
        { Name: "待激活", Id: 0 },
        { Name: "已激活", Id: 1 },
        { Name: "已取消", Id: 2 },
      ],
      statusObj: {
        0: "待激活",
        1: "已激活",
        2: "已取消",
      },
      pageIndex: 0,
      pageSize: 5,
      datas: [],
    };
  },

  created() {
    this.init();
  },

  methods: {
    // 初始化
    async init() {
      this.resetParams();
      // 加载产品列表前5条数据
      this.getOrderList();
    },

    getOrderList() {
      const bDate = getCurrentPreviousDay(120) + " 00:00:00";
      const eDate = getCurrentPreviousDay(0) + " 23:59:59";
      let sendParams = {
        query: {
          State: this.acIdx,
          TimeRange: { BeginTime: bDate, EndTime: eDate },
        },
        pager: {
          pageindex: this.pageIndex,
          pagesize: this.pageSize,
        },
      };
      getEquipAuthList(sendParams)
        .then((res) => {
          console.log("设备");
          console.log(res);
          // debugger
          this.loading = false;
          this.refreshing = false;
          if (res.Code) {
            //此时表示未返回任何数据
            this.finished = true;
          } else {
            let resDatas = res.Items;
            if (Array.isArray(resDatas)) {
              resDatas.forEach((item) => {
                item.State =
                  item.IsAuthorized == true
                    ? "已激活"
                    : item.IsAuthorized == false
                    ? "已取消"
                    : "待激活";
              });
              this.datas = this.datas.concat(resDatas);
              if (this.datas.length >= res.Pager.TotalCount) {
                this.finished = true;
              }
            }
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        })
        .finally(() => {
          // console.log("最后");
          // // debugger
          // this.loading = false;
          // this.refreshing = false;
        });
    },

    // 上拉加载
    onLoad() {
      this.pageIndex += 1;
      this.getOrderList();
    },
    // tab切换
    onTabChange(val) {
      this.resetParams();
      this.getOrderList();
    },

    resetParams() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.datas = [];
    },

    // 查看产品详情
    toOrderDetail(info) {
      info.AuditState =
        info.State == "待激活" ? 0 : info.State == "已取消" ? 2 : 1;
      handleLocalStorage.set("authInfo", info);
      this.$router.push({
        name: "AuthOrderDetail",
        query: { type: "equip" },
      });
      // this.$router.push({
      //   name: 'GoodsDetail',
      //   params: { id: productId }
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
.order-page-container {
  position: relative;
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  min-height: calc(100vh - 100px - env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  .no-order-content {
    position: unset;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform: unset;
  }
}
.order_item_con {
  // padding: 20px 0;
  .order_status_con {
    padding: 5px 8px;
    border-radius: 5px;
    background: #00c987;
    color: #fff;
    &.order_status_con_0 {
      background: #ff6a33;
    }
    &.order_status_con_2 {
      background: #999;
    }
  }
}
.top-line-box {
  font-size: 26px;

  color: #333333;
  padding: 20px;
  align-items: flex-end;
  border-bottom: 1px solid #f1f1f1;
}
.order_bottom_con {
  padding: 20px;
  font-size: 24px;
  color: #333;
  > div {
    span {
      color: #666;
      width: 150px;
      display: inline-block;
    }
  }
}
</style>
